import { render, staticRenderFns } from "./OpsGenreTagPicker.vue?vue&type=template&id=7906b158&scoped=true"
import script from "./OpsGenreTagPicker.vue?vue&type=script&lang=js"
export * from "./OpsGenreTagPicker.vue?vue&type=script&lang=js"
import style0 from "./OpsGenreTagPicker.vue?vue&type=style&index=0&id=7906b158&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7906b158",
  null
  
)

export default component.exports